<script setup>
import { computed } from 'vue';
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
const props = defineProps({
  rows: { type: Array, default: () => [] },
  mode: { type: String, default: 'money' },
});
ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);
const color = token =>
  `rgb(${getComputedStyle(document.documentElement).getPropertyValue(token).trim()})`;
const chartData = computed(() =>
  props.mode === 'members'
    ? {
        labels: props.rows.map(r => new Date(r.at).toLocaleDateString('ru-RU')),
        datasets: [
          {
            label: 'Участники',
            data: props.rows.map(r => r.count),
            borderColor: color('--blue-9'),
            tension: 0.1,
          },
        ],
      }
    : {
        labels: props.rows.map(r => r.date),
        datasets: [
          {
            label: 'Приходы',
            data: props.rows.map(r => Number(r.income_minor) / 100),
            borderColor: color('--teal-9'),
            tension: 0.1,
          },
          {
            label: 'Расходы',
            data: props.rows.map(r => Number(r.expense_minor) / 100),
            borderColor: color('--ruby-9'),
            tension: 0.1,
          },
        ],
      }
);
const options = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  interaction: { intersect: false, mode: 'index' },
  plugins: { legend: { position: 'bottom' } },
  scales: { y: { beginAtZero: true } },
};
</script>

<template>
  <div class="h-64 w-full min-w-0">
    <Line
      :data="chartData"
      :options="options"
      role="img"
      :aria-label="
        mode === 'members'
          ? 'График участников группы'
          : 'График приходов и расходов'
      "
    />
  </div>
</template>
